import {
	observer
} from 'mobx-react';
import {
	WeaDialog,
	WeaLocaleProvider,
} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@observer
export default class SyncDetailDialog extends React.Component {
	render() {
		const {
			store
		} = this.props, {
			hrmAddressBookPlus: plusStore
		} = store, {
			DIALOG_SYNCLOG_DETAIL,
			syncDetailDialog,
			syncDetailTitle,
			synclogDetail,
			operateType
		} = plusStore;

		return (
			<WeaDialog ecId={`${this && this.props && this.props.ecId || ''}_WeaDialog@zeslgg`} {...DIALOG_SYNCLOG_DETAIL} {...syncDetailDialog} title={syncDetailTitle} >
				{
					(operateType === 'sync') ? <p style={{padding: 18}}>{synclogDetail}</p>:
					<div className='hrm-log-detail'>
						<p className='title'>{getLabel(508023,'查询语句')}</p>
						<p className='content'>{synclogDetail}</p>
					</div>
				}
				
			</WeaDialog>
		)
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/addressBookPlus/SyncDetailDialog.js